import Vue from 'vue'
import Router from 'vue-router'
import { Auth } from 'aws-amplify'
import ExchangeLogin from './views/exchange/ExchangeLogin.vue'
import ReceiverDownloadLogin from './views/receiver/ReceiverDownloadLogin.vue'
import ReceiverUploadLogin from './views/receiver/ReceiverUploadLogin'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: [
    {
      path: '/exchange/login',
      name: 'exchangeLogin',
      component: ExchangeLogin,
      meta: { isPublic: true }
    },
    {
      path: '/receiver/login/download',
      name: 'receiverDownloadLogin',
      component: ReceiverDownloadLogin,
      meta: { isPublic: true }
    },
    {
      path: '/receiver/login/upload',
      name: 'receiverUploadLogin',
      component: ReceiverUploadLogin,
      meta: { isPublic: true }
    },
    {
      path: '/exchange',
      name: 'exchange',
      component: () =>
        import(
          /* webpackChunkName: "exchange" */ './views/exchange/ExchangeMain.vue'
        ),
      children: [
        {
          path: 'list',
          name: 'exchangeList',
          component: () =>
            import(
              /* webpackChunkName: "exchange" */ './views/exchange/ExchangeList.vue'
            )
        },
        {
          path: 'upload',
          name: 'upload',
          component: () =>
            import(
              /* webpackChunkName: "exchange" */ './views/exchange/ExchangeUpload.vue'
            )
        },
        {
          path: 'request',
          name: 'exchangeRequest',
          component: () =>
            import(
              /* webpackChunkName: "exchange" */ './views/exchange/ExchangeRequest.vue'
            )
        },
        {
          path: 'usage',
          name: 'exchangeUsage',
          component: () =>
            import(
              /* webpackChunkName: "exchange" */ './views/exchange/ExchangeUsage.vue'
            ),
          beforeEnter: (to, from, next) => {
            Auth.currentUserInfo()
              .then(data => {
                if (data['attributes']['custom:tenantRole'] &&
                data['attributes']['custom:tenantRole'] === 'admin') {
                  next()
                } else {
                  next({ name: 'exchangeLogin' })
                }
              })
              .catch(e => {
                next({ name: 'exchangeLogin' })
              })
          }
        },
        {
          path: ':exchange_id',
          name: 'exchangeDetail',
          component: () =>
            import(
              /* webpackChunkName: "exchange" */ './views/exchange/ExchangeDetail.vue'
            )
        },
        { path: '/', redirect: { path: '/exchange/login' } }
      ]
    },
    {
      path: '/receiver',
      name: 'receiver',
      component: () =>
        import(
          /* webpackChunkName: "receiver" */ './views/receiver/ReceiverMain.vue'
        ),
      meta: { isPublic: true },
      children: [
        {
          path: 'upload',
          name: 'receiverUpload',
          component: () =>
            import(
              /* webpackChunkName: "receiverUpload" */ './views/receiver/ReceiverUpload.vue'
            ),
          meta: { isPublic: true },
          beforeEnter: (to, from, next) => {
            if (localStorage.getItem('role') === 'receiver') {
              next()
            } else {
              next('/ReceiverDownloadLogin')
            }
          }
        },
        {
          path: 'complete',
          name: 'uploadComplete',
          component: () =>
            import(
              /* webpackChunkName: "uploadComplete" */ './views/receiver/ReceiverUploadComplete.vue'
            ),
          meta: { isPublic: true },
          beforeEnter: (to, from, next) => {
            if (localStorage.getItem('role') === 'receiver' && localStorage.getItem('status') === 'isUploaded') {
              next()
            } else {
              next({ name: 'receiverUploadLogin' })
            }
          }
        },
        {
          path: 'download',
          name: 'receiverList',
          component: () =>
            import(
              /* webpackChunkName: "receiver" */ './views/receiver/ReceiverList.vue'
            ),
          meta: { isPublic: true }
        },
        { path: '/', redirect: { path: '/receiver/login/download' } },
        { path: '/receiver/login', redirect: { path: '/receiver/login/download' } }
      ]
    },
    { path: '*', redirect: { path: '/exchange/login' } }
  ]
})

router.beforeEach((to, _, next) => {
  if (to.matched.some(record => !record.meta.isPublic)) {
    Auth.currentUserInfo()
      .then(data => {
        if (data) {
          next()
        } else {
          next({ name: 'exchangeLogin' })
        }
      })
      .catch(e => {
        next({ name: 'exchangeLogin' })
      })
  } else {
    next()
  }
})

export default router
